import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { UsersRound } from 'lucide-react';
const Community = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-2095">
      <div className="w-20 flex-shrink-0" data-id="element-2096">
        <Sidebar data-id="element-2097" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-2098">
        <Topbar data-id="element-2099" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-2100">
          <PageHeader title="Community" subtitle="Gestione community e engagement" data-id="element-2101" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-2102">
            <div className="text-center" data-id="element-2103">
              <UsersRound className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-2104" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-2105">
                Community
              </h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-2106">
                Questa pagina conterrà la gestione della community. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default Community;